import styled from "styled-components";
import { Tooltip } from "ui/base/tooltip/Tooltip";
import { AlertCircle } from "ui/icons/AlertCircle";
import { themeColor } from "ui/theme";

export const RescheduleTooltip = ({ newDate, newTime }) => (
  <Tooltip
    id={newDate + newTime}
    text={
      <TooltipContainer>
        <ContentRow>
          <RowName>New Date: </RowName>
          <span>{newDate}</span>
        </ContentRow>
        <ContentRow>
          <RowName>New Time: </RowName>
          <span>{newTime}</span>
        </ContentRow>
      </TooltipContainer>
    }
    maxWidth="content-fit"
  >
    <TooltipContent>
      <AlertCircle width={20} height={20} />
      <TooltipText>Re-schedule request pending</TooltipText>
    </TooltipContent>
  </Tooltip>
);

const TooltipContainer = styled.div`
  padding: 4px 8px;
  font-size: 14px;
  color: #191d3a60;
  font-weight: 600;
`;

const ContentRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
`;

const RowName = styled.span`
  color: ${themeColor("txt")};
`;

const TooltipContent = styled.div`
  display: flex;
  gap: 8px;
`;

const TooltipText = styled.div`
  font-weight: 600;
  text-decoration: underline;
  color: ${themeColor("blue")};
`;
